import React, { useState } from "react";
import {
    Box,
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    FormControl,
    InputLabel,
    OutlinedInput,
} from "@mui/material";

function NewRecipientForm(props) {
    return (
        <Dialog
            open={props.open}
            onClose={props.onClose}
            fullWidth
            maxWidth="md"
        >
            <DialogTitle>Add an assessor</DialogTitle>
            <DialogContent dividers={false}>
                <DialogContentText id="scroll-dialog-description" tabIndex={-1}>
                    <Box
                        component="form"
                        autoComplete="off"
                        noValidate
                        className="dialog-content"
                    >
                        <FormControl component="div" margin="normal">
                            <InputLabel
                                id="label-title"
                                sx={{
                                    backgroundColor: "#FFF",
                                    padding: "0 4px",
                                }}
                            >
                                Title
                            </InputLabel>
                            <OutlinedInput
                                id="text-title"
                                value={props.title}
                                onChange={({ target }) =>
                                    props.setTitle(target?.value)
                                }
                            />
                        </FormControl>
                        <FormControl component="div" margin="normal" fullWidth>
                            <InputLabel
                                id="label-first-name"
                                sx={{
                                    backgroundColor: "#FFF",
                                    padding: "0 4px",
                                }}
                            >
                                First name
                            </InputLabel>
                            <OutlinedInput
                                id="text-first-name"
                                value={props.firstName}
                                onChange={({ target }) =>
                                    props.setFirstName(target?.value)
                                }
                            />
                        </FormControl>
                        <FormControl component="div" margin="normal" fullWidth>
                            <InputLabel
                                id="label-last-name"
                                sx={{
                                    backgroundColor: "#FFF",
                                    padding: "0 4px",
                                }}
                            >
                                Last name
                            </InputLabel>
                            <OutlinedInput
                                id="text-last-name"
                                value={props.lastName}
                                onChange={({ target }) =>
                                    props.setLastName(target?.value)
                                }
                            />
                        </FormControl>
                        <FormControl component="div" margin="normal" fullWidth>
                            <InputLabel
                                id="label-job-role"
                                sx={{
                                    backgroundColor: "#FFF",
                                    padding: "0 4px",
                                }}
                            >
                                Job role
                            </InputLabel>
                            <OutlinedInput
                                id="text-job-role"
                                value={props.jobRole}
                                onChange={({ target }) =>
                                    props.setJobRole(target?.value)
                                }
                            />
                        </FormControl>
                        <FormControl component="div" margin="normal" fullWidth>
                            <InputLabel
                                id="label-email"
                                sx={{
                                    backgroundColor: "#FFF",
                                    padding: "0 4px",
                                }}
                            >
                                Email
                            </InputLabel>
                            <OutlinedInput
                                id="text-email"
                                value={props.email}
                                onChange={({ target }) =>
                                    props.setEmail(target?.value)
                                }
                            />
                        </FormControl>
                        <FormControl component="div" margin="normal" fullWidth>
                            <InputLabel
                                id="label-phone"
                                sx={{
                                    backgroundColor: "#FFF",
                                    padding: "0 4px",
                                }}
                            >
                                Phone
                            </InputLabel>
                            <OutlinedInput
                                id="text-phone"
                                value={props.phone}
                                onChange={({ target }) =>
                                    props.setPhone(target?.value)
                                }
                            />
                        </FormControl>
                        <FormControl component="div" margin="normal" fullWidth>
                            <InputLabel
                                id="label-address"
                                sx={{
                                    backgroundColor: "#FFF",
                                    padding: "0 4px",
                                }}
                            >
                                Address
                            </InputLabel>
                            <OutlinedInput
                                id="text-address"
                                placeholder="Address"
                                value={props.address}
                                onChange={({ target }) =>
                                    props.setAddress(target.value)
                                }
                                inputProps={{ maxLength: 255 }}
                                multiline
                                rows={2}
                            />
                        </FormControl>
                    </Box>
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button key="cancel" onClick={props.onClose}>
                    Cancel
                </Button>
                <Button
                    key="add"
                    variant="contained"
                    color="primary"
                    disableElevation
                    onClick={props.onSubmit}
                >
                    Add
                </Button>
            </DialogActions>
        </Dialog>
    );
}

function NewRecipientDialog({ open, onSave, onClose }) {
    const [title, setTitle] = useState("");
    const [firstName, setFirstName] = useState("");
    const [lastName, setLastName] = useState("");
    const [jobRole, setJobRole] = useState("");
    const [email, setEmail] = useState("");
    const [phone, setPhone] = useState("");
    const [address, setAddress] = useState("");

    const onSubmit = () => {
        onSave({ title, firstName, lastName, jobRole, email, phone, address });
        onClose();
    };

    return (
        <NewRecipientForm
            open={open}
            onClose={onClose}
            onSubmit={onSubmit}
            title={title}
            setTitle={setTitle}
            firstName={firstName}
            lastName={lastName}
            setFirstName={setFirstName}
            setLastName={setLastName}
            jobRole={jobRole}
            setJobRole={setJobRole}
            email={email}
            setEmail={setEmail}
            phone={phone}
            setPhone={setPhone}
            address={address}
            setAddress={setAddress}
        />
    );
}

export default NewRecipientDialog;
